import React from 'react'

const Loader = () => {
    return (
        <>
            < div className="loadingio-spinner-eclipse-sud2kb4xjzf" >
                <div className="ldio-rqggut5n3ml">
                    <div></div>
                </div>
            </div>
        </>
    )
}

export default Loader
